import styled from '@emotion/styled'

import { SUB_COLOR } from '@/constants/colors'

const TITLE_COLOR = '#d4d5d8'
const DIVIDER_COLOR = '#5d5f65'
const SECTION_GAP_PX = 20
const HEADER_INNER_GAP_PX = 4
const HEADER_BOTTOM_PADDING_PX = 16
const SECTION_INNER_GAP_PX = 8
const BULLET_GAP_PX = 4
const BULLET_INDENT_PX = 21
const TITLE_FONT_SIZE_PX = 15
const TITLE_LINE_HEIGHT_PX = 22
const TITLE_LETTER_SPACING_PX = -0.075
const BODY_FONT_SIZE_PX = 14
const BODY_LINE_HEIGHT_PX = 22
const HEADER_ROW_GAP_PX = 6
const CONTAINER_PADDING_BOTTOM_PX = 32
const CONTAINER_PADDING = `0 20px calc(${CONTAINER_PADDING_BOTTOM_PX}px + var(--safe-bottom, 0px))`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SECTION_GAP_PX}px;
  width: 100%;
  padding: ${CONTAINER_PADDING};
  background-color: #1b1c1d;
`

export const Hr = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid ${DIVIDER_COLOR};
`

export const WarningInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${HEADER_INNER_GAP_PX}px;
  padding-bottom: ${HEADER_BOTTOM_PADDING_PX}px;
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${HEADER_ROW_GAP_PX}px;
`

export const HeaderTitle = styled.span`
  font-size: ${TITLE_FONT_SIZE_PX}px;
  font-weight: 600;
  line-height: ${TITLE_LINE_HEIGHT_PX}px;
  letter-spacing: ${TITLE_LETTER_SPACING_PX}px;
  color: ${TITLE_COLOR};
`

export const HeaderDesc = styled.p`
  margin: 0;
  font-size: ${BODY_FONT_SIZE_PX}px;
  font-weight: 400;
  line-height: ${BODY_LINE_HEIGHT_PX}px;
  color: ${SUB_COLOR};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SECTION_INNER_GAP_PX}px;
`

export const Title = styled.h3`
  margin: 0;
  font-size: ${TITLE_FONT_SIZE_PX}px;
  font-weight: 600;
  line-height: ${TITLE_LINE_HEIGHT_PX}px;
  letter-spacing: ${TITLE_LETTER_SPACING_PX}px;
  color: ${TITLE_COLOR};
`

export const BulletList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${BULLET_GAP_PX}px;
  margin: 0;
  list-style: disc;
  padding-left: ${BULLET_INDENT_PX}px;
  font-size: ${BODY_FONT_SIZE_PX}px;
  font-weight: 400;
  line-height: ${BODY_LINE_HEIGHT_PX}px;
  color: ${SUB_COLOR};
`
